import './tag.scss';
import React from 'react';
import cx from 'classnames';
import {useNormalizedTransformer} from "../../hooks/useNormalizedTransformer";

type TagProps = {
    name?: string;
    className?: string;
    onClick?: (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent> | string
    ) => void;
    title: string;
    disabled?: boolean;
    noTransform?: boolean;
};

const Tag = ({ className, onClick, title, disabled, noTransform, name }: TagProps) => {
    const normalizeTag = useNormalizedTransformer([
        {
            search: /^.*?:/g,
            replace: ''
        },
        {
            search: /[_-]+/g,
            replace: ' '
        }
    ]);

    return (
        <div className={cx('b-tag value list-item', className)} role="button">
            <span data-testid={`tag-${name}`}>{noTransform ? title : normalizeTag(title)}</span>
            {onClick && (
                <button
                    className="b-tag__remove-button"
                    onClick={onClick}
                    disabled={disabled}
                    data-testid={`tag-remove-${name}`}
                >
                    X
                </button>
            )}
        </div>
    );
}

export default Tag;
